export default "__VITE_ASSET__B1wxO$Fm__"